export default "__VITE_ASSET__DCgytusB__"